import {
  DialogContent as MUIDialogContent,
  DialogContentProps,
} from "@mui/material";

export function DialogContent({ children }: DialogContentProps) {
  return <MUIDialogContent>{children}</MUIDialogContent>;
}
